import { createContext, useContext } from 'react';

/**
 * Lets a subtree present as member or guest regardless of the real session.
 *
 * `useGuest()` reads this first. It exists for the Lobby Lab (a dev-only tool):
 * flipping "member" there wraps the LOBBY subtree so the header, tiles and
 * CTAs render their member forms, while the app shell, socket handshake and
 * everything outside the lobby keep the real (guest) session — a design
 * preview must never make the client believe it holds credentials it does not.
 *
 * `null` (the default) means "no override; use the real session".
 */
const GuestOverrideContext = createContext<boolean | null>(null);

export const useGuestOverride = (): boolean | null => useContext(GuestOverrideContext);

export const GuestOverrideProvider = GuestOverrideContext.Provider;

export default GuestOverrideContext;
